import React from 'react'
import { Navigate } from 'react-router-dom'
import axios from 'axios'
import { useState, useEffect } from 'react'
import API_URL from '../../config'
import { setAuthToken } from '../../services/auth'

// Function to check if user is a reconciliation admin (reused from ReconciliationAdminRoute)
const useIsReconciliationAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [retries, setRetries] = useState(0)

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        // Set auth token for the request
        const token = localStorage.getItem('token')
        console.log(
          'PlaylistAdminRoute - Token from localStorage:',
          token ? `${token.substring(0, 20)}...` : 'No token found'
        )

        if (!token) {
          console.log('PlaylistAdminRoute - No token found, marking as not admin')
          setIsAdmin(false)
          setLoading(false)
          return
        }

        setAuthToken(token)
        console.log(
          'PlaylistAdminRoute - Authorization header:',
          axios.defaults.headers.common['Authorization'] ? 'Set' : 'Not set'
        )

        // Get user profile data
        console.log('PlaylistAdminRoute - Making profile request to:', `${API_URL}profile/`)
        const response = await axios.get(`${API_URL}profile/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        })
        console.log('PlaylistAdminRoute - Profile response:', response.data)

        // Check if user has staff privileges
        const hasStaffPrivilege = response.data.is_staff === true
        console.log('PlaylistAdminRoute - Is admin:', hasStaffPrivilege)

        setIsAdmin(hasStaffPrivilege)
        setError(null)
      } catch (error) {
        console.error('PlaylistAdminRoute - Error checking admin status:', error)
        console.error(
          'PlaylistAdminRoute - Error details:',
          error.response
            ? {
                status: error.response.status,
                data: error.response.data,
              }
            : 'No response data'
        )

        setError(error)

        // If we haven't tried too many times, try again
        if (retries < 3) {
          console.log('PlaylistAdminRoute - Retrying admin check, attempt:', retries + 1)
          setRetries((prev) => prev + 1)
          return // Don't set loading to false yet
        }

        setIsAdmin(false)
      } finally {
        setLoading(false)
      }
    }

    checkAdminStatus()
  }, [retries])

  return { isAdmin, loading, error }
}

// Protected route component
const PlaylistAdminRoute = ({ element }) => {
  const { isAdmin, loading, error } = useIsReconciliationAdmin()

  // Show loading state while checking permissions
  if (loading) {
    return <div className='p-4'>Checking permissions...</div>
  }

  // If there was an error but we know the user is an admin from a previous response
  if (error && isAdmin) {
    return element
  }

  // If not an admin, redirect to unauthorized page
  if (!isAdmin) {
    return <Navigate to='/unauthorized' />
  }

  // If admin, render the requested page
  return element
}

export default PlaylistAdminRoute
